import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import {
  getQueryParams,
  isoToSqlDate,
  mergeParams,
} from "../../helpers/helpers";
import AppContext from "../../container/context";
import api from "../../services/api";
import MUIDataTable from "mui-datatables";
import pedidoEvento from "../../enums/pedidoEvento";

let totais = {
  saidas: "0",
  valor: "0",
  valorComFrete: '0',
  pedidos: "0",
};

export default function RelatorioParticipacao({ history, location }) {
  const { notification } = useContext(AppContext);
  const [registros, setRegistros] = useState([]);
  const [tabela, setTabela] = useState(false);
  const [dadosFiltros, setDadosFiltros] = useState(
    mergeParams(
      {
        dataInicial: `${new Date().getFullYear()}-${
          new Date().getMonth() < 6 ? "01" : "07"
        }-01`,
        dataFinal: isoToSqlDate(new Date().toISOString()),
      },
      location
    )
  );

  useEffect(() => {
    const parametros = getQueryParams(location.search);

    if (parametros.dataInicial && parametros.dataFinal) {
      carregarRelatorio();
    }
  }, []);

  const carregarRelatorio = (filtrosEnviar = dadosFiltros) => {
    setDadosFiltros(filtrosEnviar);
    api
      .get("relatorios/saidaProdutos", filtrosEnviar)
      .then((registros) => {
        let totalPedidos = 0;
        let totalValor = 0;
        let totalValorComFrete = 0;
        let ultimoPedido = 0;
        let qtdPedidos = 0;

        registros.forEach((r) => {
          totalPedidos += 1;

          totalValor += r.quantidade * r.valorItem;
          totalValorComFrete += (r.quantidade * r.valorItem) + r.pedidoValorFrete;

          r.pedidoSituacao = r.ultimoEvento ? pedidoEvento.desc(r.ultimoEvento) : "Pendente";

          if (r.pedidoCodigo !== ultimoPedido) {
            qtdPedidos += 1;
            ultimoPedido = r.pedidoCodigo;
          }

          if (r.valorItem > 0) {
            r.valorItem = r.valorItem ? r.valorItem.toString().replace(".", ",") : '0';
          }
        });

        totalValor = totalValor.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });

        totalValorComFrete = totalValorComFrete.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });

        totais = {
          saidas: totalPedidos,
          valor: totalValor,
          pedidos: qtdPedidos,
          valorComFrete: totalValorComFrete
        };

        setRegistros(registros);
        setTabela(true);
      })
      .catch((err) => {
        console.log('err', err);
        notification("error", "Erro ao carregar o relatório");
      });
  };
  const filtros = {
    title: "Filtros",
    form: {
      dataInicial: {
        label: "Data inicial",
        type: "date",
        space: 6,
        value: dadosFiltros.dataInicial,
      },
      dataFinal: {
        label: "Data final",
        type: "date",
        space: 6,
        value: dadosFiltros.dataFinal,
      },
    },

    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      saidas: {
        label: "Saídas",
        type: "text",
        space: 4,
        readOnly: true,
        value: totais.saidas,
      },
      valor: {
        label: "Valor total itens (R$)",
        type: "text",
        space: 4,
        readOnly: true,
        value: totais.valor,
      },
      // valorComFrete: {
      //   label: "Valor com frete (R$)",
      //   type: "text",
      //   space: 3,
      //   readOnly: true,
      //   value: totais.valorComFrete,
      // },
      pedidos: {
        label: "Pedidos",
        type: "text",
        space: 4,
        readOnly: true,
        value: totais.pedidos,
      },
    },
  };

  return (
    <div>
      <Form formData={filtros} />
      {registros.length > 0 && <Form formData={fTotais} />}
      <br />
      {tabela && (
        <MUIDataTable
          title={"Saída de Produtos"}
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
}

const columns = [
  {
    name: "escolaNomeFantasia",
    label: "Escola",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "produtoCategoria",
    label: "Categoria do produto",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "produtoNome",
    label: "Produto",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "quantidade",
    label: "Quantidade",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "valorItem",
    label: "Valor unitário (R$)",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "pedidoValorFrete",
    label: "Valor do frete (R$)",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "pedidoCodigo",
    label: "Código do pedido",
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: "pedidoSituacao",
    label: "Situação ",
    options: {
      filter: false,
      sort: true,
    },
  },
];

const options = {
  filterType: "checkbox",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "participacao.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: false,
      useDisplayedRowsOnly: true,
    },
  },
};
